import { RichIconTypes } from '@eika/rich-icon';
export const richIconSelector = (subType) => {
    switch (subType) {
        case 'UPLOAD_DOCUMENTATION':
            return RichIconTypes.VENTER;
        case 'SIGN':
        case 'CONFIRM':
            return RichIconTypes.TOMMEL_OPP;
        default:
            return RichIconTypes.TRAFIKKLYS_GULT;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmljaEljb25TZWxlY3Rvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy93aWRnZXRzL0tyZWRpdHRiYW5rZW5DdXN0b21lclRhc2tzL3JpY2hJY29uU2VsZWN0b3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBSWhELE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHLENBQUMsT0FBNEIsRUFBaUIsRUFBRTtJQUM1RSxRQUFRLE9BQU8sRUFBRSxDQUFDO1FBQ2QsS0FBSyxzQkFBc0I7WUFDdkIsT0FBTyxhQUFhLENBQUMsTUFBTSxDQUFDO1FBQ2hDLEtBQUssTUFBTSxDQUFDO1FBQ1osS0FBSyxTQUFTO1lBQ1YsT0FBTyxhQUFhLENBQUMsVUFBVSxDQUFDO1FBQ3BDO1lBQ0ksT0FBTyxhQUFhLENBQUMsZUFBZSxDQUFDO0lBQzdDLENBQUM7QUFDTCxDQUFDLENBQUMifQ==